import React, { useState } from "react";
import { recipientimport } from "../../../services/CommonService";
import { toast } from "react-toastify";

const Recipientsimport = ({ setIsEffect }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Only CSV files are allowed!");
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.warning("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      await recipientimport(formData);
      toast.success("File uploaded successfully");
      setShowModal(false);
      setIsEffect(prev => !prev);
    } catch (error) {
      console.error("Error uploading file:", error.response ? error.response.data : error.message);
      toast.error('File already uploaded or invalid format');
    }
  };

  const handleDownloadTemplate = () => {
    const headers = [
      "first_name", "last_name", "email", "country_id", "mobile", "company_name",
      "address_1", "address_2", "city", "state", "zip_code", "address_country_id"
    ];

    const csvContent = headers.join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "recipient_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="motion-card">
        <button className="recipint_import_btn" data-toggle="tooltip" data-placement="right"
          title="Import Recipients"
          data-bs-original-title="Import Recipients" onClick={() => setShowModal(true)}>
          <i class="bi bi-box-arrow-in-down me-2"></i>
          Import
        </button>
      </div>

      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Import File</h5>
                <button type="button" className="btn btn-close" onClick={() => setShowModal(false)}>
                  <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
              </div>
              <div className="modal-body">
                <input type="file" className="form-control" onChange={handleFileChange} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary me-auto" onClick={handleDownloadTemplate}>
                  Download Format
                </button>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleUpload}>Upload</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && <div className="modal-backdrop show" onClick={() => setShowModal(false)}></div>}
    </div>
  );
};

export default Recipientsimport;
